import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const TransporterMappedInfoComponent = ({ agents, selectedTransporters, onInnerFormChange }: any) => (
  <>
    <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>

          <InputContainer
            label="Agents"
            labelField="Name"
            list={agents}
            onValueChange={(newValue: any) => {
              const valueData: any = newValue.map((option: any) => option?.value || '');
              onInnerFormChange(
                valueData,
                'MappedAgents.AgentIds',
                selectedTransporters?.MappedAgents
              );
            }}
            type="multiselect"
            valueField="Id"
            value={selectedTransporters?.MappedAgents?.AgentIds} />



        </div>
      }
      expandedPanel="mappedInfo"
      headerTitle="Mapped Info"
    />
  </>
)
export default TransporterMappedInfoComponent;
